
import { defineComponent, watchEffect } from 'vue';
import Card from '@/components/ui-elements/card/Card.vue';
import CardContent from '@/components/ui-elements/card/CardContent.vue';
import CardFooter from '@/components/ui-elements/card/CardFooter.vue';
import CardHeader from '@/components/ui-elements/card/CardHeader.vue';
import WarningIcon from '@/components/ui-elements/icons/WarningIcon.vue';
import useBudgetTable from '@/hooks/useBudgetTable';
import useCurrency from '@/hooks/useCurrency';
import useTimestamp from '@/hooks/useTimestamp';
import useUtils from '@/hooks/useUtils';

export default defineComponent({
	components: {
		Card,
		CardContent,
		CardFooter,
		CardHeader,
		WarningIcon,
	},
	props: {
		data: {
			required: true,
			type: Array,
		},
		type: {
			required: true,
			type: String,
		},
	},
	setup(props, { emit }) {
		const { getExpenseValue } = useBudgetTable();
		const { formatDollar } = useCurrency();
		const { formatDate } = useTimestamp();
		const { toTitleCase } = useUtils();

		const headers: string[] = [];
		let total = 0;

		const setHeaders = () => {
			if (props.type === 'vehicles') {
				headers.push('vehicle');
				headers.push('mileage');
			} else {
				headers.push('name');
			}

			if (props.type !== 'miscellaneous') {
				headers.push('type');
			}

			if (!['banks', 'investments'].includes(props.type)) {
				headers.push('paid_date');
			}

			if (
				['vehicles', 'credit-cards', 'loans', 'housing'].includes(
					props.type
				)
			) {
				headers.push('balance');
			}

			headers.push('amount');
		};

		const setTotalAmount = () => {
			if (props.data) {
				total = (props.data as any)[
					props.type.replace('-', '_')
				].reduce((acc: any, item: any) => {
					return acc + Number(item.amount);
				}, 0);
				emit('set-table-total', total);
			}
		};

		watchEffect(() => {
			setHeaders();
			setTotalAmount();
		});

		return {
			formatDate,
			formatDollar,
			getExpenseValue,
			headers,
			total,
			toTitleCase,
		};
	},
});
